import { render } from "./Start.vue?vue&type=template&id=7d9fc71f&scoped=true"
const script = {}

import "./Start.vue?vue&type=style&index=0&id=7d9fc71f&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9fc71f"]])

export default __exports__